import axios from 'axios';
import urlUtil from './util-url.js';

export default new (function () {
	let storage = {};
	const localStorageKey = 'metaUtil';
	const metaUtil = this;

	this.reset = function () {
		storage = {};
	};

	this.setItem = function (id, data) {
		storage[id] = data;
		if (isNaN(id) || typeof data !== 'object') {
			console.log(id, data);
			throw new Error('metaUtil.setItem: Invalid arguments');
		}
		try {
			sessionStorage.setItem(localStorageKey, JSON.stringify(storage)); // дебаунс может сделать...
		} catch (e) {
			const isTooBig =
				e instanceof DOMException &&
				// everything except Firefox
				(e.code === 22 ||
					// Firefox
					e.code === 1014 ||
					// test name field too, because code might not be present
					// everything except Firefox
					e.name === 'QuotaExceededError' ||
					// Firefox
					e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
				// acknowledge QuotaExceededError only if there's something already stored
				storage &&
				storage.length !== 0;
			if (isTooBig) {
				console.error(
					'metaUtil.setItem: метаданные АРМ не поместились в сторедж, то есть кеш метаданных для этого АРМ работать не будет',
				);
			} else {
				throw e;
			}
		}
	};

	this.getAll = function () {
		return storage;
	};

	// Асинхронное (промис) получение метаданных АРМ либо из локалсторедж либо с сервера
	this.getItem = function (PAR) {
		const defaultParams = {
			armId: null, // обязательно
			vpId: null, // обязательно. Игнорируется сервером, если у АРМ в метаданных есть ignoreCvpmId
			isCard: false, // признак контекста, см. PIRS2018-2013
			useCache: false, // клиентский кеш метаданных. Требует переписывания с учетом контекста (isCard)!
		};
		PAR = Object.assign(defaultParams, PAR);
		const { specMode } = PAR;

		let storedData;
		const storedStr = sessionStorage.getItem(localStorageKey);
		storedData = storedStr ? Object.assign(storage, JSON.parse(storedStr)) : storage;
		let ret;

		if (storedData[PAR.armId] && PAR.useCache) {
			ret = new Promise(function (resolve) {
				resolve(storedData[PAR.armId]);
			});
		} else {
			let armContextParam = PAR.isCard ? '?_arm_context=CARD' : ''; // PIRS2018-2013

			// Передаем ID родительского арма - PIRS-2-10938
			if (PAR.parentArmId) {
				armContextParam += `${armContextParam ? '&' : '?'}parent_arm_id=${PAR.parentArmId}`;
			}

			const url = `${urlUtil.getDomain(false) + urlUtil.getPath({ specMode }) + PAR.vpId}/${
				PAR.armId
			}${armContextParam}`;
			ret = axios
				.get(url)
				.then(function (res) {
					if (res.data && res.data.id) {
						metaUtil.setItem(res.data.id, res.data);

						// PIRS-2-10996 - выносим сводный список групп из контрола доступа в модель
						const { rowAccess } = res.data;
						if (rowAccess) {
							const { globalGroups = [], localGroups = [], virtualGroups = [] } = rowAccess;
							rowAccess.groups = [
								...virtualGroups,
								...[...globalGroups, ...localGroups].sort((a, b) => {
									const nameA = a.name.toLowerCase();
									const nameB = b.name.toLowerCase();
									if (nameA < nameB) {
										return -1;
									}
									if (nameA > nameB) {
										return 1;
									}

									return 0;
								}),
							];
						}

						return res.data;
					}

					console.error('Ошибка получения метаданных (возможно, невалидный JSON)', res);
				})
				.catch(function (thrown) {
					// ахтунг! в p_list.vue и p_card.vue находятся одинаковые обработчики ошибок запроса данных (плюс аналогичный - в util-meta.js)
					console.log(thrown);
					let thrownMsg = '';
					if (axios.isCancel(thrown)) {
						console.log('Axios request canceled', thrown.message);
						return;
					}

					if (thrown && thrown.response) {
						const status = thrown.response.status;
						if (status === 401) {
							document.dispatchEvent(new Event('need-auth'));
							// cms-app слушает это событие и перезагружает страницу, чтобы появилась форма авторизации
						}
						if (status === 403) {
							if (window.UARM_AUTH_CHECK) {
								window.UARM_AUTH_CHECK(true);
							}
							thrownMsg = `Ошибка доступа к АРМ № ${PAR.armId} (код 403)`;
						} else if (status === 404) {
							thrownMsg = `Метаданные АРМ № ${PAR.armId} не найдены`;
						} else {
							thrownMsg = `Ошибка ${status}. \n${(thrown.response.data && thrown.response.data.message) || ''}`;
						}
					} else {
						thrownMsg = 'Ошибка получения метаданных АРМ';
					}
					const userLogin = window.PAGEDATA?.login;
					if (userLogin) {
						thrownMsg += `\nЛогин: ${userLogin}`;
					}
					const rid = thrown?.response?.data?.rid || thrown?.rid || '<none>';
					if (rid) {
						thrownMsg += `\nИдентификатор запроса: ${rid}`;
					}
					throw thrownMsg;
				});
		}

		// если в следующем then (кот навешивается после return в этой функции)
		// случается ошибка рантайма, она замалчивается
		// я не нашел способа выводить её по умолчанию
		// так что или писать код без ошибок или добавлять catch после metaUtil.getItem(...).then(...)

		// ret.finally(function() {})

		/*ret.then(function(armMeta) {
			return armMeta
		})*/

		return ret;
	};

	this.getLen = function () {
		return Object.keys(storage).length;
	};
})();
